/**
 * "Anchor Sprint at a glance" — the key facts block on
 * /partners/anthropic-claude-partner/ (2026-10-08).
 *
 * Why: Google's AI Mode answer for "claude partner malaysia" quoted hard numbers
 * from another firm while our page said only "Claude Certified Architects on the
 * team". Answer engines lift short, self-contained sentences with a number in
 * them, so every fact here is one plain sentence that names Anchor Sprint and
 * stands on its own when quoted out of context.
 *
 * Rules: verified facts only; never compare with or name other partners; never
 * "Anthropic-certified" or "certified by Anthropic"; never "SME". The approved
 * Anthropic line is rendered separately, verbatim and in English on every locale
 * (CLAUDE_PARTNER_APPROVED_LINE), so it is not in this list.
 *
 * Sources:
 *  - 10 Claude Certified Architects (CCAR-F), Malaysian-owned, on-demand FDE
 *    teams, RAG and custom agents: Jazz, 2026-10-08.
 *  - Authorised NVIDIA DGX Spark + Lenovo reseller: Jazz, 2026-10-04/08 (memory authorised-reseller-status).
 *  - 14 agent builds with evaluation scorecards: the 14 spokes in
 *    src/content/agent-use-cases/index.ts (agentUseCases), each with a snapshot
 *    scorecard and an evaluation section, matching "fourteen agent builds are
 *    published with their evaluation scorecards" on /invest/. Update both when
 *    a spoke is added.
 *
 * Each string is a t() key: add any edit to ms.json and zh.json as well.
 */
export const anthropicPartnerKeyFacts: readonly string[] = [
  "Anchor Sprint is a Malaysian homegrown (Malaysian-owned) company.",
  "Anchor Sprint has a full team of 10 Claude Certified Architects (CCAR-F).",
  "Anchor Sprint builds RAG pipelines and custom Claude agents.",
  "Anchor Sprint provides on-demand FDE (forward-deployed engineering) teams that embed with your team to build and ship Claude agents.",
  "Anchor Sprint has offices in Setia Alam, Shah Alam, Selangor, and at Suntec, Singapore.",
  "Anchor Sprint is an authorised reseller of NVIDIA DGX Spark, Dell and Lenovo GPU workstations and servers for teams that need AI hardware on their own premises.",
  "Anchor Sprint quotes and invoices in MYR, and in SGD in Singapore.",
  "Anchor Sprint is an HRD Corp approved training provider: its Claude training is HRD Corp claimable, including official Claude certification prep with the exam included.",
  "Anchor Sprint holds Malaysia Digital status from MDEC.",
  "Anchor Sprint has published 14 agent builds with their evaluation scorecards in its agent use case directory.",
];
